import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundInvoiceEmail.SendEmail.IRequest;
type Response = Api.Sales.ContractRefundInvoiceEmail.SendEmail.IResponse;
type Params = Api.Sales.ContractRefundInvoiceEmail.SendEmail.IParams;
type Headers = Api.Sales.ContractRefundInvoiceEmail.SendEmail.IHeaders;
const url = '/api/Sales/ContractRefundInvoiceEmail/SendEmail/:contractRefundInvoiceId';
export default async function contractRefundInvoiceEmailSendEmailApi({
  body,
  params,
}: {
  body: Request;
  params: Params;
}): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { contractRefundInvoiceId: params.contractRefundInvoiceId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
